import React, { useState } from 'react'
import { YouTubeEmbed } from 'react-social-media-embed';
import { NavLink } from "react-router";
import Gallery from "./gallery.js";
import jp2 from "../images/Featured Work/2.jpg";
import jp3 from "../images/Featured Work/3.jpg";
import jp9 from "../images/Featured Work/9.jpg";
import poster from "../images/Featured Work/poster.jpg";
import PC from "../images/Personal_Cloud.jpg";
import Logo from "../images/logo.png";

export default function Home() {
	document.title = "Home - Byokeh Studio";
	let metas = document.getElementsByTagName("meta");
	metas.description.content = ""
	const images = [jp2, jp3, jp9];
	const [lightbox, setLightbox] = useState({ open: false, index: 0 });

	const openLightbox = (index) => {
		setLightbox({ open: true, index });
	};

	const closeLightbox = () => {
		setLightbox({ open: false, index: 0 });
	};

	const nextImage = () => {
		setLightbox((prev) => ({ ...prev, index: (prev.index + 1) % images.length }));
	};

	const prevImage = () => {
		setLightbox((prev) => ({ ...prev, index: (prev.index - 1 + images.length) % images.length }));
	};
	return (
		<>
			<div className="landing">
				<div className="headl slide">
					<img src={Logo} alt="" />
					<p>
						We’re Byokeh Studio
					</p>
				</div>
				<div className="headm">
					<p>With an eye for visuals and a mind for logic, we craft stories through photography & videography, while building seamless digital experiences through code.</p>
					<h1>A Visual Creator & Developer</h1>
				</div>
				<div className="headr">
					<p>Lives by visuals & code</p>
				</div>
			</div>
			<div className="container">
				<div className="headc">
					<h1 className="containerHead">Featured Work</h1>
					<h4 className="containerHead explore">
						<NavLink to="/projects">Explore More</NavLink>
						<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-arrow-right" viewBox="0 0 16 16">
							<path fill-rule="evenodd" d="M1 8a.5.5 0 0 1 .5-.5h11.793l-3.147-3.146a.5.5 0 0 1 .708-.708l4 4a.5.5 0 0 1 0 .708l-4 4a.5.5 0 0 1-.708-.708L13.293 8.5H1.5A.5.5 0 0 1 1 8" />
						</svg>
					</h4>
				</div>
				<h2 className='feature-heads'>
					<svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" fill="currentColor" class="bi bi-caret-right-fill" viewBox="0 0 16 16">
						<path d="m12.14 8.753-5.482 4.796c-.646.566-1.658.106-1.658-.753V3.204a1 1 0 0 1 1.659-.753l5.48 4.796a1 1 0 0 1 0 1.506z" />
					</svg>
					Builds
				</h2>
				<div className="featured-devs">
					<div className="web-proj">
						<img src="https://raw.githubusercontent.com/Shuvadip-Ghosh/Groomify/refs/heads/master/screenshot.png" alt="" />
						<h3><a href="https://shuvadip-ghosh.github.io/Groomify/" target="_blank" rel="noopener noreferrer">Groomify</a></h3>
						<p>Groomify is a sleek and responsive website for pet grooming business.</p>
					</div>
					<div className="web-proj">
						<img src={PC} alt="" />
						<h3><a href="https://github.com/Shuvadip-Ghosh/My_world" target="_blank" rel="noopener noreferrer">Personal Cloud</a></h3>
						<p>A self-hosted backup solution that transforms my home server into a personal drive.</p>
					</div>
				</div>
				<h2 className='feature-heads'>
					<svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" fill="currentColor" class="bi bi-caret-right-fill" viewBox="0 0 16 16">
						<path d="m12.14 8.753-5.482 4.796c-.646.566-1.658.106-1.658-.753V3.204a1 1 0 0 1 1.659-.753l5.48 4.796a1 1 0 0 1 0 1.506z" />
					</svg>
					Photography & Videography
				</h2>
				<div className="featured-imgs">
					<Gallery images={images} />
				</div>
				<div className="featured-vids">
					<div className="yt-vid">
						<YouTubeEmbed className='dd' url="https://www.youtube.com/watch?v=AEVvrPWujXQ" />
					</div>
					<div className="yt-vid">
						<YouTubeEmbed className='dd' url="https://www.youtube.com/watch?v=x2hcyAoU0yA" placeholderImageUrl={poster} />
					</div>
					{/* <p>Captured Using <br /> Nothing Phone 3a & <br />Digitek DSG 010 Pro<span><br /></span><br />Edited Using <br /> Davinci Resolve</p> */}
				</div>
			</div>
			<div className="services container">
				<h1 className='containerHead'>Services</h1>
				<div className="servh">
					<div className="servicel">
						Driven by curiosity and passion,<br /> I constantly explore new ways to merge creativity with technology. My journey has equipped me with skills I’m always perfecting and evolving.
					</div>
					<div className="servicer">
						<div className="service">
							<h2>
								<svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" fill="currentColor" class="bi bi-code" viewBox="0 0 16 16">
									<path d="M5.854 4.854a.5.5 0 1 0-.708-.708l-3.5 3.5a.5.5 0 0 0 0 .708l3.5 3.5a.5.5 0 0 0 .708-.708L2.707 8zm4.292 0a.5.5 0 0 1 .708-.708l3.5 3.5a.5.5 0 0 1 0 .708l-3.5 3.5a.5.5 0 0 1-.708-.708L13.293 8z" />
								</svg>
								Web Development
							</h2>
							<p>Designing and coding responsive websites that balance aesthetics with performance.</p>
						</div>
						<div className="service">
							<h2>
								<svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" fill="currentColor" class="bi bi-code-slash" viewBox="0 0 16 16">
									<path d="M10.478 1.647a.5.5 0 1 0-.956-.294l-4 13a.5.5 0 0 0 .956.294zM4.854 4.146a.5.5 0 0 1 0 .708L1.707 8l3.147 3.146a.5.5 0 0 1-.708.708l-3.5-3.5a.5.5 0 0 1 0-.708l3.5-3.5a.5.5 0 0 1 .708 0m6.292 0a.5.5 0 0 0 0 .708L14.293 8l-3.147 3.146a.5.5 0 0 0 .708.708l3.5-3.5a.5.5 0 0 0 0-.708l-3.5-3.5a.5.5 0 0 0-.708 0" />
								</svg>
								Software Development
							</h2>
							<p>Building efficient desktop and terminal tools that simplify everyday tasks.</p>
						</div>
						<div className="service">
							<h2>
								<svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" fill="currentColor" class="bi bi-camera-reels" viewBox="0 0 16 16">
									<path d="M6 3a3 3 0 1 1-6 0 3 3 0 0 1 6 0M1 3a2 2 0 1 0 4 0 2 2 0 0 0-4 0" />
									<path d="M9 6h.5a2 2 0 0 1 1.983 1.738l3.11-1.382A1 1 0 0 1 16 7.269v7.462a1 1 0 0 1-1.406.913l-3.111-1.382A2 2 0 0 1 9.5 16H2a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2zm6 8.73V7.27l-3.5 1.555v4.35zM1 8v6a1 1 0 0 0 1 1h7.5a1 1 0 0 0 1-1V8a1 1 0 0 0-1-1H2a1 1 0 0 0-1 1" />
									<path d="M9 6a3 3 0 1 0 0-6 3 3 0 0 0 0 6M7 3a2 2 0 1 1 4 0 2 2 0 0 1-4 0" />
								</svg>
								Visual Storytelling
							</h2>
							<p>Photography & videography that capture moments and emotions with artistic precision.</p>
						</div>
						<div className="service">
							<h2>
								<svg xmlns="http://www.w3.org/2000/svg" height="40" viewBox="0 -960 960 960" width="40"><path d="M760-120 480-400l-94 94q8 15 11 32t3 34q0 66-47 113T240-80q-66 0-113-47T80-240q0-66 47-113t113-47q17 0 34 3t32 11l94-94-94-94q-15 8-32 11t-34 3q-66 0-113-47T80-720q0-66 47-113t113-47q66 0 113 47t47 113q0 17-3 34t-11 32l494 494v40H760ZM600-520l-80-80 240-240h120v40L600-520ZM240-640q33 0 56.5-23.5T320-720q0-33-23.5-56.5T240-800q-33 0-56.5 23.5T160-720q0 33 23.5 56.5T240-640Zm240 180q8 0 14-6t6-14q0-8-6-14t-14-6q-8 0-14 6t-6 14q0 8 6 14t14 6ZM240-160q33 0 56.5-23.5T320-240q0-33-23.5-56.5T240-320q-33 0-56.5 23.5T160-240q0 33 23.5 56.5T240-160Z" /></svg>
								Post-Production
							</h2>
							<p>Professional video editing and color work to craft compelling narratives.</p>
						</div>
					</div>
				</div>
			</div>
		</>
	)
}
